/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * PreferenceSettingStyles
 *
 * @file PreferenceSettingStyles.jsx
 * @author Anuja Gaikwad
 * @since 1.0.27
 */
import { makeStyles } from '@material-ui/core/styles';
import mixins from '../../../assets/styles/mixins.scss';

const usePreferenceSettingStyles = makeStyles({
  dialogPaper: {
    width: '584px',
    maxWidth: '800px',
    borderRadius: '24px',
    padding: '48px',
    gap: 24,
    maxHeight: '767px'
  },
  titleRoot: { padding: 0, margin: 0 },
  contentRoot: {
    padding: 0,
    margin: 0,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  },
  actionsRoot: { padding: 0, margin: 0 },
  title: {
    color: mixins.color_text_primary,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize24,
    fontWeight: mixins.fontWeight500,
    lineHeight: '32px',
    letterSpacing: '-0.48px'
  },
  subtitle: {
    color: mixins.color_text_primary,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize16,
    fontWeight: mixins.fontWeight400,
    lineHeight: mixins.lineHeight24,
    marginTop: 16
  },
  sectionsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12
  },
  sectionCard: {
    background: mixins.feedBackColor,
    borderRadius: '16px',
    padding: '24px',
    display: 'flex',
    flexDirection: 'column'
  },
  mainRow: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'nowrap',
    marginBottom: 5
  },
  label: {
    color: mixins.color_text_primary,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize16,
    fontWeight: mixins.fontWeight500,
    lineHeight: mixins.lineHeight20
  },
  subLabel: {
    color: mixins.zambezi,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: '12px',
    lineHeight: '14px',
    maxWidth: '460px',
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
    fontWeight: mixins.fontWeight500,
    '& b': {
      fontWeight: mixins.fontWeight600
    }
  },
  learnMore: {
    color: mixins.amethyst,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: '12px',
    fontWeight: mixins.fontWeight600,
    lineHeight: '14px',
    cursor: 'pointer',
    marginTop: 12,
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  closeButton: {
    position: 'absolute',
    right: 16,
    top: 16
  },
  footer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  confirmButton: {
    background: mixins.amethyst,
    fontFamily: mixins.fontFamilyPlusSans,
    color: mixins.chalkWhiteFont,
    borderRadius: '1000px',
    fontSize: mixins.fontSize14,
    padding: '8px 16px',
    fontWeight: mixins.fontWeight500,
    height: '34px',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    lineHeight: '16px',
    border: 'none',
    outline: 'none',
    transition: 'background-color 0.15s ease-in-out',

    '&:hover': {
      backgroundColor: mixins.amethystColorV2
    },

    '&:disabled': {
      backgroundColor: mixins.bulkEditCtaButtonDisabledBGColor,
      color: mixins.bulkEditCtaButtonDisabledColor,
      cursor: 'not-allowed'
    }
  },
  studyPrepDivider: {
    width: '100%',
    height: '1px',
    backgroundColor: mixins.bulkEditCtaButtonDisabledBGColor, // or Figma divider color
    marginTop: '12px',
    marginBottom: '12px'
  }

});

export default usePreferenceSettingStyles;
